import * as BABYLON from '@babylonjs/core';
import '@babylonjs/core/Particles/index'
import BaseObject from "../BaseObject";

export default class Explosion extends BaseObject
{
    show()
    {
        let self = this;

        let path = process.env.VUE_APP_FOLDER + (process.env.VUE_APP_FOLDER.slice(-1) === '/' ? '' : '/');
        BABYLON.ParticleHelper.BaseAssetsUrl = path + 'js/babylon/';
        BABYLON.ParticleSystemSet.BaseAssetsUrl = path + 'js/babylon/';


        // Explosion
        if (!self.explosion)
        {
            // https://doc.babylonjs.com/how_to/particlehelper
            // https://github.com/BabylonJS/Babylon.js/tree/master/assets/particles/systems
            BABYLON.ParticleHelper.CreateAsync("explosion", this.scene).then((set) => {
                var p = new BABYLON.Vector3(13, 1.6, .2);
                set.systems[0].emitter = p;
                
                set.start();
                self.explosion = set;
            });
        } 
        else
        {
            self.explosion.start();
        }

        // Smoke
        if (!self.smoke)
        {
            BABYLON.ParticleHelper.CreateAsync("smoke", this.scene, false).then((set) =>
            {
                set.systems[0].emitter = new BABYLON.Vector3(0, 7, 0);
                set.start();
                self.smoke = set;
            });
        }
        else
        {
            self.smoke.start();
        }
    }

    hide()
    {
        let self = this;

        // Feuer entfernen
        //this.fire.dispose();
        //this.fire = false;

        // Rauch entfernen
        //this.smoke.dispose();
        //this.smoke = false;


        if (self.explosion)
        {

            // Feuer anhalten
            for (let id in this.explosion.systems)
            {
                if (this.explosion.systems.hasOwnProperty(id))
                {
                    // Emitter anhalten
                    this.explosion.systems[id].stop();
                    // erzeuges Elemente entfernen
                    this.explosion.systems[id].reset();
                }
            }

            // Rauch anhalten
            for (let id in this.smoke.systems)
            {
                if (this.smoke.systems.hasOwnProperty(id))
                {
                    // Emitter anhalten
                    this.smoke.systems[id].stop();
                    // erzeuges Elemente entfernen
                    this.smoke.systems[id].reset();
                }
            }

        }

    }
}
